import { order as orderApi } from "@squareup/sq-addons-web-sdk";
import { createLogic } from "redux-logic";

import { AppState } from "store/store";
import {
  ENROLL_CUSTOMER,
  EnrollCustomerAction,
  ADD_CUSTOMER_TO_SALE,
  AddCustomerToSaleAction,
  REMOVE_CUSTOMER_FROM_SALE,
  GET_CUSTOMER,
  GetCustomerAction,
  RequestContext,
} from "./types";
import { createLoyaltyAccount } from "store/api/customer/createLoyaltyAccount";
// import { retrieveCustomer } from 'store/api/customer/retrieveCustomer';
// import { retrieveLoyaltyAccount } from 'store/api/customer/retrieveLoyaltyAccount';
import { findMember, getRewards } from "lava/api";
import {
  addCustomer,
  addCustomerToSaleFulfilled,
  addCustomerToSaleRejected,
  enrollCustomerFulfilled,
  enrollCustomerRejected,
  getCustomerFulfilled,
  getCustomerRejected,
  removeCustomerFromSaleFulfilled,
  removeCustomerFromSaleRejected,
  // setPointBalance,
} from "./actions";
import { addDiscount, fetchDiscountsFulfilled } from "store/discounts";
import { getCustomerDisplayName } from "utils/customer";

export const createLoyaltyAccountLogic = createLogic({
  type: ENROLL_CUSTOMER,
  latest: true,

  async process(
    {
      action,
      getState,
    }: { action: EnrollCustomerAction; getState: () => object },
    dispatch,
    done
  ) {
    const posContext = (getState() as AppState).context.posContext;

    const phoneNumber = action.payload.phoneNumber;

    try {
      await createLoyaltyAccount(posContext, phoneNumber);

      dispatch(enrollCustomerFulfilled());
    } catch (error) {
      dispatch(enrollCustomerRejected(error as Error));
    } finally {
      done();
    }
  },
});

export const addCustomerToSaleLogic = createLogic({
  type: ADD_CUSTOMER_TO_SALE,
  latest: true,

  async process(
    { action }: { action: AddCustomerToSaleAction },
    dispatch,
    done
  ) {
    const customer = Object.assign({}, action.payload.customer);
    const hasName = customer.familyName || customer.givenName;
    if (!hasName) {
      customer.givenName = getCustomerDisplayName(customer);
    }

    try {
      await orderApi.addCustomer(customer);
      dispatch(addCustomerToSaleFulfilled());
    } catch (error) {
      dispatch(addCustomerToSaleRejected(error as Error));
    } finally {
      done();
    }
  },
});

export const removeCustomerFromSaleLogic = createLogic({
  type: REMOVE_CUSTOMER_FROM_SALE,
  latest: true,

  async process(_, dispatch, done) {
    try {
      await orderApi.removeCustomer();
      dispatch(removeCustomerFromSaleFulfilled());
    } catch (error) {
      dispatch(removeCustomerFromSaleRejected(error as Error));
    } finally {
      done();
    }
  },
});

export const getCustomerLogic = createLogic({
  type: GET_CUSTOMER,
  latest: true,

  async process(
    { action, getState }: { action: GetCustomerAction; getState: () => object },
    dispatch,
    done
  ) {
    const posContext = (getState() as AppState).context.posContext;
    const order = await orderApi.retrieve();
    const referenceId = action.payload.referenceId;
    const context = action.payload.context;

    try {
      if (context === RequestContext.SDK) {
        const customer = await orderApi.getCustomer();

        // Making this forward compatible when the SDK returns undefined customer.
        if (!customer) {
          throw new Error("No customer has been added to sale.");
        }

        // Add customer to redux.
        dispatch(addCustomer(customer, context));

        // Add customer to sale because if customer exists in the SDK, customer
        // has already been added to sale.
        dispatch(addCustomerToSaleFulfilled());

        // Set getCustomer state.
        dispatch(getCustomerFulfilled());

        done();
        return;
      }

      if (!referenceId) {
        throw new Error("No customer has been added to sale.");
      }

      // console.log(posContext);

      // const account = await retrieveLoyaltyAccount(posContext, referenceId);
      const customers = await findMember(posContext, referenceId);

      dispatch(addCustomer(customers[0], context));
      dispatch(getCustomerFulfilled());
    } catch (error) {
      dispatch(getCustomerRejected(context, error as Error));
    }

    done();
  },
});
